export default "__VITE_ASSET__DzAidb5S__"